import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { Label, Input } from '@polichat/flamboyant';
import styles from '../../styles.module.css';
import { useBotFlowService } from '../../useBotFlowService';
import { useEffect } from 'react';
export function BotForm() {
  const { control, setValue } = useFormContext();
  const commercialType = useWatch({ control, name: 'commercial.type' });
  const botValue = useWatch({ control, name: 'botflow.flow_id' });

  const { bots, isLoading, error } = useBotFlowService({
    commercialType,
  });

  /**
   * Quando listagem de bot é exibida, o campo botflow é resetado para evitar erro de uncontrolled input
   */
  useEffect(() => {
    setValue('botflow', {
      flow_id: '',
    });
  }, []);

  useEffect(() => {
    /**
     * Quando não há fluxos disponíveis (ou seja, não há bot para o mesmo tipo de item e canal selecionado)
     * o campo botflow é colocado como string 'null' para evitar erro de campo não selecionado, o valor será tratado ao enviar para o backend.
     * Caso o campo existam bots para a opção comercial o valor é alterado para vazio para que valide a seleção e exiba a lista de bots.
     */
    if (bots?.length === 0 && !error) {
      setValue('botflow', {
        flow_id: 'null',
      });
    } else {
      if (bots?.length > 0 && botValue === 'null') {
        setValue('botflow', {
          flow_id: '',
        });
      }
    }
  }, [bots, botValue, commercialType, error, setValue]);

  return (
    <div
      className={styles.fieldContainer}
      data-testid="finish-chat-bot-container"
    >
      <Controller
        name="botflow.flow_id"
        control={control}
        render={({ field, fieldState }) => (
          <>
            <Label
              htmlFor="botflow"
              className={styles.fieldLabel}
              data-testid="finish-chat-bot-label"
            >
              Enviar para fluxo automático do bot
              <span className={styles.fieldLabelRequired}>*</span>:
            </Label>
            <Input
              id="botflow"
              type="select"
              {...field}
              invalid={!isLoading && !!fieldState.error}
              disabled={isLoading}
              data-testid="finish-chat-bot-select"
            >
              <option
                value=""
                disabled
                data-testid="finish-chat-bot-option-loading"
              >
                {isLoading ? 'Carregando...' : 'Selecione o fluxo do bot'}
              </option>
              {bots?.length === 0 && !error && !isLoading && (
                <option
                  value="null"
                  disabled
                  data-testid="finish-chat-bot-option-no-flow"
                >
                  Nenhum fluxo encontrado para este canal.
                </option>
              )}
              {bots?.map((bot: any) => (
                <option
                  key={bot.id}
                  value={bot.legacy_flow_id}
                  data-testid={`finish-chat-bot-option-${bot.id}`}
                >
                  {bot.name}
                </option>
              ))}
            </Input>
            {fieldState.error && (
              <span
                className={styles.fieldError}
                data-testid="finish-chat-bot-error"
              >
                {fieldState?.error?.message}
              </span>
            )}
          </>
        )}
      />
    </div>
  );
}
